import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { rtdbPlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/database'
import VueHtml2Canvas from 'vue-html2canvas';
import "regenerator-runtime";
// import VueMeta from 'vue-meta'
import VueHead from 'vue-head'

Vue.use(rtdbPlugin);
Vue.use(VueHtml2Canvas);
// Vue.use(VueMeta)
Vue.use(VueHead)

export const db = firebase
  .initializeApp({ databaseURL: 'https://dexter-9cb27-default-rtdb.europe-west1.firebasedatabase.app/' })
  .database()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
